import React from 'react';
import { Star } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '../Carousel';
import { Card, CardContent } from '../Card';
export function Testimonials() {
  const reviews = [{
    quote: "Deep Clean Cleaners completely transformed my apartment before I moved out. They didn't miss a single spot, and I got my full deposit back. Highly recommend their move-out service!",
    name: 'Sarah Jenkins',
    location: 'Downtown Apartment'
  }, {
    quote: 'I use them for my Airbnb turnover and they are lifesavers. Always on time, incredibly thorough, and my guests constantly leave 5-star reviews for cleanliness.',
    name: 'Michael Chen',
    location: 'Airbnb Superhost'
  }, {
    quote: "The deep cleaning service is worth every penny. My house hasn't looked this good since the day we moved in. The team was friendly, professional, and detail-obsessed.",
    name: 'Emily Rodriguez',
    location: 'Suburban Home'
  }];
  return <section className="py-20 md:py-32 bg-brand-sky" data-id="element-191">
      <div className="container mx-auto px-4 md:px-6" data-id="element-192">
        <div className="text-center mb-16" data-id="element-193">
          <h2 className="font-display font-bold text-3xl md:text-4xl lg:text-5xl text-brand-navy" data-id="element-194">
            What Our Clients Say
          </h2>
        </div>

        <div className="max-w-5xl mx-auto relative" data-id="element-195">
          <Carousel opts={{
          align: 'start',
          loop: true
        }} className="w-full" data-id="element-196">
            <CarouselContent className="-ml-4 md:-ml-6" data-id="element-197">
              {reviews.map((review, index) => <CarouselItem key={index} className="pl-4 md:pl-6 md:basis-1/2 lg:basis-1/3" data-id="element-198">
                  <Card className="h-full bg-brand-white border-none shadow-sm rounded-2xl" data-id="element-199">
                    <CardContent className="p-8 flex flex-col h-full" data-id="element-200">
                      <div className="flex gap-1 mb-6" data-id="element-201">
                        {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-brand-aqua text-brand-aqua" data-id="element-202" />)}
                      </div>
                      <blockquote className="text-brand-navy/80 text-lg leading-relaxed mb-8 flex-grow" data-id="element-203">
                        "{review.quote}"
                      </blockquote>
                      <div className="mt-auto" data-id="element-204">
                        <div className="font-display font-bold text-brand-navy text-lg" data-id="element-205">
                          {review.name}
                        </div>
                        <div className="text-brand-aqua font-medium text-sm" data-id="element-206">
                          {review.location}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block" data-id="element-207">
              <CarouselPrevious className="bg-brand-white text-brand-navy hover:bg-brand-aqua hover:text-white border-none -left-12 h-12 w-12" data-id="element-208" />
              <CarouselNext className="bg-brand-white text-brand-navy hover:bg-brand-aqua hover:text-white border-none -right-12 h-12 w-12" data-id="element-209" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}